import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { FaEdit, FaTrashAlt } from 'react-icons/fa'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import CountryService from 'services/CountryService'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import DestinationsService from '../../../../services/DestinationsService'
import {isArrayNotEmpty, isObjectEmpty, scrollToHtmlElementById, sortObjectList, isCompletedHotelInfoHistory} from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import SelectInput from '../../../atoms/form/SelectInput/SelectInput'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './LongDistanceTransportation.scss'

class LongDistanceTransportation extends Component {

    constructor(props) {
        super(props)
        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const countryCode = hotelInfo?.address?.country
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)

        if (!hotelCode || !hotelInfo || !countryCode) {
            this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
        }

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            countryCode: countryCode,
            continueFlow: this.props.history.location?.state?.continueFlow,
            distanceUnits: getSessionItem(SessionConst.DISTANCE_UNIT_LABEL),
            longDistanceTransportationEntries: [],
            localTransportationEntries: [],
            otherDestinationEntries: {},
            isEdit: false,
            editIndex: -1,
            showNewTransportationFields: false,
            deleteIndex: -1,
            showDeleteModal: false,
            initialValues: { ...this.initialValues },
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            transportationCodeOptions: [],
            hotelInfoCompletedHistory: hotelInfoCompletedHistory
        }
    }

    initialValues = {
        transportationName: '',
        transportationCode: '',
        country: '',
        state: '',
        distance: 0,
        direction: '',
        stateOptions: []
    }

    validationSchema = Yup.object().shape({
        transportationName: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            .max(FormConst.DESTINATION_NAME_MAX_LENGTH, `Up to ${FormConst.DESTINATION_NAME_MAX_LENGTH} characters allowed`)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
        transportationCode: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        country: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        state: Yup.string().test('State is required for countries that have subdivisions', FormConst.VALIDATION_ERROR_REQUIRED, val => isArrayNotEmpty(this.state.initialValues.stateOptions) ? !!val : true),
        distance: Yup.number().required(FormConst.VALIDATION_ERROR_REQUIRED)
            .min(0, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_ZERO)
            .max(FormConst.MAX_DESTINATION_DISTANCE, FormConst.VALIDATION_ERROR_DESTINATIONS_DISTANCE),
        direction: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
    })

    async componentDidMount() {
        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            let hotelDestinations = this.state.hotelInfoCompletedHistory.newEntity?.hotelDestinations?.hotelDestinations;

            if (hotelDestinations) {
                await this.buildFormValues(hotelDestinations);
            } else {
                this.setState({error: 'Could not retrieve details', isLoading: false})
            }
        } else {
            await DestinationsService.getHotelDestinations({ hotelCode: this.state.hotelCode })
                .then(async response => {
                    let hotelDestinations = response?.hotelDestinations;
                    if (hotelDestinations) {
                        await this.buildFormValues(hotelDestinations);
                    }
                }).catch(error => {
                    this.setState({ error: 'Could not retrieve destination details', isLoading: false })
                });
        }
    }

    async buildFormValues(hotelDestinations) {
        let existingLongDistanceTransportationEntries = []
        let existingLocalTransportationEntries = []
        let otherDestinationEntries = {}

        // Fliter out transportation and other destination entries
        const transportation = hotelDestinations.transportation
        otherDestinationEntries = { ...hotelDestinations, transportation: undefined }

        // Split transportation entries in long distance and local transportation entries
        if (isArrayNotEmpty(transportation)) {
            transportation.forEach(transportationEntry => {
                if (transportationEntry.destinationType === FormConst.DESTINATION_TYPE_LONG_DISTANCE_TRANSPORTATION) {
                    existingLongDistanceTransportationEntries.push(transportationEntry)
                } else if (transportationEntry.destinationType === FormConst.DESTINATION_TYPE_LOCAL_TRANSPORTATION) {
                    existingLocalTransportationEntries.push(transportationEntry)
                }
            })
        }

        // Get country service data and acceptable values for transportation code for options lists
        await CountryService.getCountries({
            hotelCode: this.state.hotelCode
        }).then(async countryServiceResponse => {
            let countryOptions = countryServiceResponse.countries.map(country => {
                return {
                    label: country.name,
                    value: country.iso2Code
                }
            })

            countryOptions = sortObjectList(countryOptions, 'label')

            await DestinationsService.getAcceptableValues({
                hotelCode: this.state.hotelCode, queryParams: {
                    code: FormConst.DESTINATION_CODE_LONG_DISTANCE_TRANSPORT
                }
            }).then(acceptableValuesResponse => {
                this.setState({
                    longDistanceTransportationEntries: existingLongDistanceTransportationEntries,
                    localTransportationEntries: existingLocalTransportationEntries,
                    otherDestinationEntries: otherDestinationEntries,
                    isLoading: false,
                    countryOptions: countryOptions,
                    transportationCodeOptions: acceptableValuesResponse.acceptableValues.map(option => {
                        return {
                            label: option.value,
                            value: option.key
                        }
                    })
                })
            }).catch(error => {
                this.setState({
                    longDistanceTransportationEntries: existingLongDistanceTransportationEntries,
                    localTransportationEntries: existingLocalTransportationEntries,
                    otherDestinationEntries: otherDestinationEntries,
                    countryOptions: countryOptions,
                    error: 'Could not retrieve transportation codes',
                    showErrorModal: true,
                    isLoading: false
                })
            })
        }).catch(error => {
            this.setState({
                error: 'Could not retrieve country details',
                isLoading: false,
                longDistanceTransportationEntries: existingLongDistanceTransportationEntries,
                localTransportationEntries: existingLocalTransportationEntries,
                otherDestinationEntries: otherDestinationEntries,
            })
        })
    }

    handleSubmit = (formData) => {
        let longDistanceTransportationEntries = this.state.longDistanceTransportationEntries
        const newEntry = {
            destinationType: FormConst.DESTINATION_TYPE_LONG_DISTANCE_TRANSPORTATION,
            name: formData.transportationName.trim(),
            code: formData.transportationCode,
            proximity: {
                distanceValue: formData.distance,
                distanceUnit: this.state.distanceUnits,
                direction: formData.direction
            },
            address: {
                state: formData.state || undefined,
                country: formData.country
            }
        }

        if (this.state.isEdit) {
            // Edit existing entry
            longDistanceTransportationEntries[this.state.editIndex] = newEntry
        } else {
            longDistanceTransportationEntries.push(newEntry)
        }

        let transportationEntries = [...longDistanceTransportationEntries]
        if (isArrayNotEmpty(this.state.localTransportationEntries)) {
            transportationEntries = [...transportationEntries, ...this.state.localTransportationEntries]
        }

        let newDestinationEntries
        if (isObjectEmpty(this.state.otherDestinationEntries)) {
            newDestinationEntries = {
                transportation: transportationEntries
            }
        } else {
            newDestinationEntries = {
                ...this.state.otherDestinationEntries,
                transportation: transportationEntries
            }
        }

        this.props.onPut({ hotelCode: this.state.hotelCode, formData: newDestinationEntries })

        this.setState({
            pendingLongDistanceTransportationEntries: [...longDistanceTransportationEntries],
            newPendingTransportationEntry: { ...formData },
            isLoading: true,
            loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT
        })
    }

    handleDelete = (index) => {
        this.setState({ showDeleteModal: true, deleteIndex: index })
    }

    handleClearForm = () => {
        this.setState({ showResetModal: true })
    }

    discardNewFields = (formikResetForm) => {
        formikResetForm({ ...this.initialValues })
        // Scroll the table into view after discarding
        scrollToHtmlElementById('transportation-table')
        this.setState({
            initialValues: { ...this.initialValues },
            isEdit: false,
            editIndex: -1,
            showNewTransportationFields: false,
            showResetModal: false
        })
    }

    handleProceed = () => {
        this.props.history.push(RouteConst.ROUTE_DESTINATIONS_PAGE)
    }

    onEdit = async (index) => {
        const entryToEdit = this.state.longDistanceTransportationEntries[index]

        await CountryService.getCountries({
            hotelCode: this.state.hotelCode,
            queryParams: { countryCode: entryToEdit.address.country, expand: 'subdivisions' }
        }).then(async countryServiceResponse => {

            const country = countryServiceResponse.countries[0]
            const states = country.subdivisions

            const stateOptions = states.map(state => {
                return {
                    label: state.name,
                    value: state.isoCode.split('-')[1]
                }
            })
            this.setState({
                isEdit: true,
                editIndex: index,
                isLoading: false,
                initialValues: {
                    transportationName: entryToEdit.name,
                    transportationCode: entryToEdit.code,
                    country: entryToEdit.address.country,
                    state: entryToEdit.address.state || '',
                    distance: entryToEdit.proximity.distanceValue,
                    direction: entryToEdit.proximity.direction,
                    stateOptions: stateOptions
                },
                showNewTransportationFields: true
            })
        }).catch(error => {
            this.setState({
                isLoading: false,
                showErrorModal: true,
                error: 'Could not retrieve country details'
            })
        })
    }

    onDelete = () => {
        let index = this.state.deleteIndex
        let longDistanceTransportationEntries = [...this.state.longDistanceTransportationEntries]
        longDistanceTransportationEntries.splice(index, 1)

        let newDestinationEntries

        let transportationEntries = []

        // Calculate transportation entries
        if (isArrayNotEmpty(longDistanceTransportationEntries)) {
            transportationEntries = [...longDistanceTransportationEntries]
        }
        if (isArrayNotEmpty(this.state.localTransportationEntries)) {
            transportationEntries = [...transportationEntries, ...this.state.localTransportationEntries]
        }

        // Calculate destination entries
        if (transportationEntries.length > 0) {
            // Other destination entries are present
            if (!isObjectEmpty(this.state.otherDestinationEntries)) {
                newDestinationEntries = {
                    ...this.state.otherDestinationEntries,
                    transportation: transportationEntries
                }
            }
            // Other destination entries missing
            else {
                newDestinationEntries = {
                    transportation: transportationEntries
                }

            }
        } else {
            // No transportation entries
            newDestinationEntries = {
                ...this.state.otherDestinationEntries
            }
        }

        this.props.onPut({ hotelCode: this.state.hotelCode, formData: newDestinationEntries })

        this.setState({
            pendingLongDistanceTransportationEntries: [...longDistanceTransportationEntries],
            newPendingTransportationEntry: undefined,
            isLoading: true,
            loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT,
            showDeleteModal: false
        })
    }

    addTransportation = () => {
        const country = this.state.countryCode
        this.getStatesForCountry(country)
        this.setState({
            isEdit: false, editIndex: -1, showNewTransportationFields: true,
            initialValues: {
                ...this.state.initialValues,
                country: country,
                stateOptions: []
            }
        })
    }

    getStatesForCountry = (country, values) => {
        this.props.onGetStates({ hotelCode: this.state.hotelCode, queryParams: { countryCode: country, expand: 'subdivisions' } })
        this.setState({ isLoading: true, initialValues: { ...values, country: country, state: '', stateOptions: [] } })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription,
                    pendingLongDistanceTransportationEntries: undefined,
                    newPendingTransportationEntry: undefined,
                    initialValues: {
                        ...this.initialValues,
                        ...this.state.newPendingTransportationEntry
                    }
                })
            } else {

                if (this.props.httpAction === actionTypes.ASYNC_ACTIONS.GET_STATES) {
                    const country = this.props.destinationsResponse.countries[0]
                    const states = country.subdivisions

                    const stateOptions = states.map(state => {
                        return {
                            label: state.name,
                            value: state.isoCode.split('-')[1]
                        }
                    })

                    this.setState({
                        isLoading: false,
                        initialValues: {
                            ...this.state.initialValues,
                            country: country.iso2Code,
                            state: '',
                            stateOptions: sortObjectList(stateOptions, 'label')
                        }
                    })
                } else {
                    // Scroll the table into view after saving
                    scrollToHtmlElementById('transportation-table')
                    this.setState({
                        isLoading: false,
                        longDistanceTransportationEntries: this.state.pendingLongDistanceTransportationEntries,
                        initialValues: { ...this.initialValues },
                        showNewTransportationFields: false,
                        isEdit: false, editIndex: -1,
                        deleteIndex: -1,
                        showDeleteModal: false
                    })
                }
            }
        }
    }

    render() {
        let formTable = <table id='transportation-table' className='table table-striped transportation-table'>
            <thead>
                <tr>
                    <th>Transportation Name</th>
                    <th className='d-none d-lg-table-cell'>Transportation Code</th>
                    <th className='d-none d-lg-table-cell'>Country</th>
                    <th className='d-none d-lg-table-cell'>State</th>
                    <th>Edit</th>
                    <th>Delete</th>
                </tr>
            </thead>
            <tbody>
                {
                    isArrayNotEmpty(this.state.longDistanceTransportationEntries)
                        ? this.state.longDistanceTransportationEntries.map((transportation, index) => {
                            return <tr key={index}>
                                <td>{transportation.name}</td>
                                <td className='d-none d-lg-table-cell'>{transportation.code}</td>
                                <td className='d-none d-lg-table-cell'>{transportation.address.country}</td>
                                <td className='d-none d-lg-table-cell'>{transportation.address.state}</td>
                                <td><Button name={<FaEdit />} role='link' className={this.state.showNewTransportationFields ? 'icon-link-disabled' : 'icon-link'} onClick={() => this.onEdit(index)} overridedisabledflag='true' /></td>
                                <td><Button name={<FaTrashAlt />} role='link' className={this.state.showNewTransportationFields ? 'icon-link-disabled' : 'icon-link'} onClick={() => this.handleDelete(index)} /></td>
                            </tr>
                        })
                        : <tr>
                            <td colSpan={6}>There are no entries for long distance transportation</td>
                        </tr>
                }
            </tbody>
        </table>

        return (
            <Formik
                initialValues={this.state.initialValues}
                validationSchema={this.validationSchema}
                enableReinitialize={true}
                onSubmit={(data, { setSubmitting, resetForm }) => {
                    setSubmitting(true)
                    this.handleSubmit(data)
                    setSubmitting(false)
                    resetForm()
                }}>
                {
                    ({ values, errors, touched, dirty, isSubmitting, isValid, resetForm, handleChange }) => (
                        <Form className='transportation-form'>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                                    <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_DESTINATIONS_PAGE}>Destinations</NavLink></li>
                                    <li className="breadcrumb-item active" aria-current="page">Long Distance Transportation</li>
                                </ol>
                            </nav>
                            <p className='hotel-destinations-type'>Long Distance Transportation</p>
                            <p className='helper-text'>{FormConst.LONG_DISTANCE_TRANSPORTATION_HELPER_TEXT}</p>

                            {formTable}

                            {
                                this.state.longDistanceTransportationEntries.length < FormConst.DESTINATIONS_CATEGORY_TRANSPORTATION_MAX_COUNT
                                && <div className='new-transportation-fields-toggle'>
                                    <Button
                                        name='Add Transportation'
                                        id='add-transportation-button'
                                        disabled={this.state.showNewTransportationFields}
                                        onClick={this.addTransportation} />
                                </div>
                            }

                            {/* Show new transportation fields only when add button is clicked */}
                            {
                                this.state.showNewTransportationFields
                                && <div id='new-transportation-collapse-fields'>
                                    <div className='new-transportation-form-fields'>
                                        <TextInput name='transportationName' type='text' label='Transportation Name' isrequired='true' />
                                        <SelectInput
                                            name='transportationCode'
                                            type='text'
                                            label='Transportation Code'
                                            options={this.state.transportationCodeOptions}
                                            isrequired='true' />
                                        <SelectInput
                                            name='country'
                                            type='text'
                                            label='Country'
                                            onInput={(e) => this.getStatesForCountry(e.target.value, values)}
                                            options={this.state.countryOptions}
                                            isrequired='true' />
                                        {
                                            isArrayNotEmpty(values.stateOptions)
                                            && <SelectInput
                                                name='state'
                                                type='text'
                                                label='State'
                                                isrequired={FormConst.VALUE_TRUE_STRING}
                                                options={values.stateOptions} />
                                        }
                                        <TextInput
                                            name='distance'
                                            type='number'
                                            label='Distance'
                                            suffix={this.state.distanceUnits}
                                            min={0}
                                            max={FormConst.MAX_DESTINATION_DISTANCE}
                                            step='0.5'
                                            isrequired='true' />
                                        <SelectInput
                                            name='direction'
                                            label='Direction'
                                            options={FormConst.DIRECTION_OPTIONS}
                                            isrequired='true' />
                                    </div>
                                    <Row>
                                        <Col xs={3} sm={2} lg={1}><Button role='link' type="submit" name={FormConst.SAVE_LINK_TEXT} className="new-transportation-action-button" formNoValidate /></Col>
                                        <Col xs={4} sm={2} lg={1}><Button role='link' name={FormConst.DISCARD_LINK_TEXT} className="new-transportation-action-button" onClick={() => {
                                            if (dirty) {
                                                this.handleClearForm()
                                            } else {
                                                this.discardNewFields(resetForm)
                                            }
                                        }
                                        }
                                            overridedisabledflag='true' /></Col>
                                    </Row>

                                </div>
                            }

                            {
                                this.state.showNewTransportationFields
                                && <p className='error text-center'>Please save or discard your changes to proceed</p>
                            }

                            <FormFooter
                                form={{
                                    previous: { title: 'Airports', route: RouteConst.ROUTE_AIRPORTS_PAGE },
                                    next: { title: 'Local Transportation', route: RouteConst.ROUTE_LOCAL_TRANSPORTATION_PAGE },
                                }}
                                submitName='Proceed to Destinations'
                                onSubmit={this.handleProceed}
                                submitDisabled={this.state.showNewTransportationFields}
                                noReset />
                            <FormModal
                                id='transportation-page-save-modal'
                                title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                hotelInfo={this.state.hotelInfo}
                                body={<h5>{this.state.loadingMessage}</h5>}
                                show={this.state.isLoading}
                                isLoadingIndicator />
                            <FormModal
                                id='transportation-page-discard-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_DISCARD_ACTION_TITLE}
                                body={<h5>{FormConst.MODAL_DISCARD_ACTION_TEXT}</h5>}
                                proceed={() => {
                                    this.discardNewFields(resetForm)
                                }}
                                cancel={() => { this.setState({ showResetModal: false }) }}
                                show={this.state.showResetModal} />
                            <FormModal
                                id='transportation-page-delete-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={'Delete Transportation'}
                                body={<h5>{FormConst.MODAL_DELETE_ACTION_TEXT}</h5>}
                                proceed={this.onDelete}
                                cancel={() => { this.setState({ showDeleteModal: false }) }}
                                show={this.state.showDeleteModal} />
                            <FormModal
                                id='transportation-page-error-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                body={<h5>{this.state.errorMessage}</h5>}
                                isError
                                cancel={() => { this.setState({ showErrorModal: false }) }}
                                show={this.state.showErrorModal} />
                        </Form>
                    )
                }
            </Formik>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        destinationsResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count,
        httpAction: state.reducer.httpAction
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGet: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_HOTEL_DESTINATIONS_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode })),
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_DESTINATIONS_NAME, actionTypes.ASYNC_ACTIONS.PUT, data)),
        onGetStates: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_DESTINATIONS_NAME, actionTypes.ASYNC_ACTIONS.GET_STATES, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(LongDistanceTransportation, SideNavEntryMapping.HOTEL_DESTINATIONS))